export default "__VITE_ASSET__BJluN8ML__"